import styled from 'styled-components'

import colors from '@settings/styleSettings'

export const ButtonOption = styled.div`
    display: flex;
    font-size: 14px;
    color: ${colors.strongGray};
    border-radius: 12px;
    cursor: pointer;
    margin-top: 3px;
    margin-left: 10px;
`
export const Divisor = styled.div`
    width: 100%;
    height: 0.5pt;
    background-color: ${colors.softGray};
`
